import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";
const style = () => {
    const { colorText, space05 } = theme();
    return StyleSheet.create({
        action: {
            color: colorText,
            paddingTop: space05,
        },
    });
};
export { style };
